import './table_of_contents_item_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'radioInput'
  ]

  select () {
    this.radioInputTarget.checked = true
  }
}
